import { Col3Col9, Input, ThresholdPill } from '@aon/aon-tws-common-ui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';
import { EditState, IPageFlowElementModel, ITranslationEditItem } from '../../../../models';
import { PageFlowElementModalUtil } from '../../../../utilities/PageFlowElementModalUtil';
import { BodyCopyMediumContainer, LimitContainer } from '../../../common';
import { TranslationEditor } from '../../../translations/TranslationEditor';
import { PageFlowQuestionSection } from '../PageFlowQuestionSection';
import { IPageFlowElementModalProps, PageFlowElementModal } from './PageFlowElementModal';

const SectionHeaderInput = styled(Input).attrs<{}>({})`
	max-width: unset;
`;
SectionHeaderInput.displayName = 'SectionHeaderInput';

const SelectContainer = styled.div.attrs<{}>({
	className: 'tws-select-container',
})`
	width: 50%;
`;
SelectContainer.displayName = 'SelectContainer';

export const SectionHeaderModal = (props: IPageFlowElementModalProps) => {
	const handleEffect = () => {
		setHeaderTextError(false);
		if (props.pageFlowElement) {
			setHeaderText(props.pageFlowElement.text ? props.pageFlowElement.text.textValue : '');
			setTranslations(props.pageFlowElement.translations);
		} else {
			setHeaderText('');
			setTranslations(surveyElement.translations);
		}
	};

	useEffect(() => {
		PageFlowElementModalUtil.HandleEffect(props, setQuestionId, setQuestionError, setSurveyElement);
		handleEffect();
		return setDefaultState;
	}, [props.pageFlowElement, props.questions, props.maxId, props.isOpen]);

	const title = props.pageFlowElement
		? ContentConstants.LOGIC_AND_LAYOUT.EDIT_SECTION_HEADER
		: ContentConstants.LOGIC_AND_LAYOUT.ADD_SECTION_HEADER;

	const [headerTextError, setHeaderTextError] = useState(false);
	const [headerText, setHeaderText] = useState(props.pageFlowElement?.text ? props.pageFlowElement.text.textValue : '');
	const [surveyElement, setSurveyElement] = useState<IPageFlowElementModel>(PageFlowElementModalUtil.InitializeSurveyElement(props));
	const [translations, setTranslations] = useState(props.pageFlowElement ? props.pageFlowElement.translations : surveyElement.translations);
	const [questionId, setQuestionId] = useState('');
	const [questionError, setQuestionError] = useState(false);
	const [questionList, setQuestionList] = useState(PageFlowElementModalUtil.InitializeQuestionList(props, false));

	const onTranslationChange = (translationItems: ITranslationEditItem[]) => {
		setTranslations(translationItems);
	};

	const onChange = (e: any) => {
		setHeaderText(e.target.value);
	};

	const setDefaultState = () => {
		PageFlowElementModalUtil.SetDefaultState(props, setQuestionId, setQuestionError, setSurveyElement, setQuestionList, false);
		setHeaderText('');
		setHeaderTextError(false);
		setTranslations(surveyElement.translations);
	};

	const isValid = () => {
		const questionValid = PageFlowElementModalUtil.IsValid(questionId, setQuestionError);
		if (headerText === '') {
			setHeaderTextError(headerText === '');
			return false;
		}

		if (!questionValid) {
			return false;
		}

		return true;
	};

	const handleSubmit = () => {
		if (isValid()) {
			if (surveyElement.text.textValue !== headerText) {
				surveyElement.text.editState = EditState.Update;
			}

			surveyElement.text.textValue = headerText ? headerText : '';
			surveyElement.translations = translations;
		}

		PageFlowElementModalUtil.HandleSubmit(props, questionId, surveyElement, setQuestionError, setSurveyElement, isValid);
	};

	const handleClose = () => {
		PageFlowElementModalUtil.HandleClose(setDefaultState, props.onClose);
	};

	return (
		<PageFlowElementModal {...props} title={title} onSubmit={handleSubmit} onClose={handleClose} contentFullWidth={true}>
			<PageFlowElementModalUtil.PageFlowContainer>
				<Col3Col9 label={ContentConstants.LOGIC_AND_LAYOUT.SECTION_HEADER} className='tws-section-header'>
					<SectionHeaderInput
						placeholder={ContentConstants.LOGIC_AND_LAYOUT.SECTION_HEADER_PLACEHOLDER}
						error={headerTextError}
						message={ContentConstants.LOGIC_AND_LAYOUT.SECTION_HEADER_ERROR_MESSAGE}
						value={headerText}
						onChange={onChange}
					/>
					<LimitContainer>
						<BodyCopyMediumContainer>{ContentConstants.CUSTOM_QUESTION_RECOMMENDED_TEXT}</BodyCopyMediumContainer>
						<ThresholdPill size='sm' count={headerText.length} threshold={100} showThresholdCount={true} />
					</LimitContainer>
				</Col3Col9>
				{props.supportedCultures === undefined
					? 0 > 1
					: props.supportedCultures.length > 1 && (
							<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_DIMENSION_TRANSLATIONS} className='tws-section-header-translations'>
								<TranslationEditor
									enableHtmlEditor={false}
									hasDefaultTranslation={headerText?.trim().length > 0}
									property='IPageFlowElementModel'
									propertyDisplayName={ContentConstants.TRANSLATIONS_SECTION_HEADER}
									onChange={onTranslationChange}
									inputType={'input'}
									translations={translations}
									showErrors={false}
								/>
							</Col3Col9>
					  )}
				<Col3Col9 label={ContentConstants.LOGIC_AND_LAYOUT.BEFORE_QUESTION} className='tws-section-header-question'>
					<SelectContainer>
						<PageFlowQuestionSection
							questions={questionList}
							questionError={questionError}
							questionId={questionId}
							handleQuestionChange={(value: any) => PageFlowElementModalUtil.HandleQuestionChange(value, setQuestionId, setQuestionError)}
						/>
					</SelectContainer>
				</Col3Col9>
			</PageFlowElementModalUtil.PageFlowContainer>
		</PageFlowElementModal>
	);
};
